import type { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';

import { queryClient } from '@/app/query-client';
import { AuthProvider } from '@/features/auth/session';
import { ActiveOrganizationProvider } from '@/features/organization/active-organization-context';

export function AppProviders({ children }: { readonly children: ReactNode }): ReactNode {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ActiveOrganizationProvider>{children}</ActiveOrganizationProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
